const blockBlocBoutonDAction = {
  'blocks.bloc-bouton-d-action': {
    populate: '*',
  },
};

const blockBlocEquipe = {
  'blocks.bloc-equipe': {
    populate: [
      'experts.image',
      'button'
    ]
  },
};

const blockBlocFAQ = {
  'blocks.bloc-faq': {
    populate: [
      'items.checklist',
      'items.primaryButton',
      'items.secondaryButton'
    ]
  },
};

const blockBlocHero = {
  'blocks.bloc-hero': {
    populate: '*',
  },
};

const blockBlocListe = {
  'blocks.bloc-liste': {
    populate: '*',
  },
};

const blockBlocListeMedia = {
  'blocks.bloc-liste-and-media': {
    populate: [
      'sections.icon',
      'image',
      'button'
    ]
  },
};

const blockBlocMarques = {
  'blocks.bloc-marques': {
    populate: [
      'brands.image',
    ]
  },
};

const blockBlocMiseEnAvant = {
  'blocks.bloc-mise-en-avant': {
    populate: '*'
  },
};

const blockBlocMiseEnAvantCommande = {
  'blocks.bloc-mise-en-avant-commande': {
    populate: '*'
  },
};

const blockBlocReassurance = {
  'blocks.bloc-reassurance': {
    populate: [
      'items.icon',
      'button',
      'reinsuranceLine',
    ]
  },
};

const blockBlocTexte = {
  'blocks.bloc-texte': {
    populate: '*'
  },
};

const blockBlocTexteMedia = {
  'blocks.bloc-texte-and-media': {
    populate: '*'
  },
};

const blockBlocListeCards = {
  'blocks.bloc-liste-cards': {
    populate: [
      'cards.image',
      'cards.cta'
    ]
  },
};

// blockSection* only available for Home Page 
const blockSectionEnTete = {
  'home.section-en-tete': {
    populate: [
      'cover',
      'checklist.icon',
      'button',
      'keyFigures'
    ],
  },
};

const blockSectionAvis = {
  'home.section-avis': {
    populate: '*'
  },
};

const blockSectionActualite = {
  'home.section-actualite': {
    populate: '*'
  },
};

const blockSectionAvantages = {
  'home.section-avantages': {
    populate: [
      'image',
      'sections.icon'
    ]
  },
};

// Sections
const sectionsSectionPourQui = {
  'sections.section-pour-qui': {
    populate: [
      'image',
      'items.icon'
    ]
  },
};

const sectionsSectionAvantagesPneumaclic2 = {
  'sections.section-avantages-pneumaclic-2': {
    populate: [
      'cards.icon'
    ]
  },
};

const sectionsSectionRecyclage = {
  'sections.section-recyclage': {
    populate: '*'
  },
};

export const blocks = {
  on: {
    ...blockBlocBoutonDAction,
    ...blockBlocEquipe,
    ...blockBlocFAQ,
    ...blockBlocHero,
    ...blockBlocListe,
    ...blockBlocListeMedia,
    ...blockBlocMarques,
    ...blockBlocMiseEnAvant,
    ...blockBlocMiseEnAvantCommande,
    ...blockBlocReassurance,
    ...blockBlocTexte,
    ...blockBlocTexteMedia,
    ...blockSectionEnTete,
    ...blockSectionAvis,
    ...blockSectionActualite,
    ...blockSectionAvantages,
    ...blockBlocListeCards,
    ...sectionsSectionPourQui,
    ...sectionsSectionAvantagesPneumaclic2,
    ...sectionsSectionRecyclage,
  },
};

export const seo = {
  populate: '*'
};

export const localizations = {
  populate: '*'
};